import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { getIssue } from "../services/supportIssuesService";
import "./supportIssueDetail.css";
import { getLuxonDate } from "../utility/dateFunctions";

const SupportIssueDetail = () => {
	const location = useLocation();
	const [issue, setIssue] = useState({});

	useEffect(() => {
		const loadIssue = async () => {
			const id = location.state.params;
			console.info("id: " + id);
			const result = await getIssue(id);
			console.info(result);
			setIssue(result);
		};

		loadIssue();
	}, [location.state.params]);

	const handleReplyClick = () => {};

	return (
		<div className="gridContainer">
			<div className="label">Name:</div>
			<div className="value">{issue.first_name + " " + issue.last_name}</div>
			<div className="label">Email:</div>
			<div className="value">{issue.email}</div>
			<div className="label">Date/Time:</div>
			<div className="value">{getLuxonDate(issue.updatedAt)}</div>{" "}
			<div className="label">Status:</div>
			<div className="value">{issue.status}</div>
			<div className="label">Message:</div>
			<div className="value">{issue.message}</div>{" "}
			<div>
				<Button variant="primary" onClick={() => handleReplyClick()}>
					Reply
				</Button>
			</div>
		</div>
	);
};

export default SupportIssueDetail;
